import { gql } from '@apollo/client';
import { rateUnitFragment, sellerFragment } from 'helper/fragment';

export const ORDERED = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  query orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      orders {
        id
        sellerCommissionAmount
        bid {
          id
          price
          quantity
          quantityUnit
          createdAt
          bidderRole
          status
          bidder {
            firstName
            lastName
          }
          parentBid {
            id
            childBids {
              id
              price
              quantity
              quantityUnit
              createdAt
              bidderRole
              bidder {
                firstName
                lastName
              }
            }
          }
          total
        }
        orderType
        offer {
          id
          offerType
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }
        demand {
          id
          demandType
        }
        forwardOffer {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        forwardDemand {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        foreignOffer {
          id
          expectedShipmentDate
          maxDeliveryDelay
          minDeliveryDelay
          minShipmentDelay
          maxShipmentDelay
        }
        foreignDemand {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        quantityUnit
        isPaid
        isLogisticSelf
        prePaymentPercentage
        approvalStatus
        comment
        buyer {
          ...sellerInfo
          id
        }
        seller {
          ...sellerInfo
          kyc {
            gstLocation
          }
          id
        }
        status
        rate
        quantity
        rateUnit {
          ...rateUnitInfo
        }
        grade {
          id
          name
        }
        deliveryAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        billingAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        orderLogistics {
          id
          rateUnit {
            ...rateUnitInfo
          }
          invoice {
            id
            isCancelled
            invoiceStatus
          }
          driverName
          deliveryDate
          orderLogisticStatus
          driverNumber
          callingCode {
            id
            callingCode
          }
          logisticDeliveryTerm
          cancellationReason
          vehicle
          vehicleNumber
          transportName
          transportLR
          loadingCharges
          otherCharges
          freight
          weightSlipDoc
          lrDoc
          vehicleNumberImage
          loadingImage
          loadingQty
          loadingQtyUnit
          pickupAddress {
            id
            houseNumber
            street
            area
            city {
              id
            }
            state {
              id
            }
            country {
              id
            }
            pinCode
          }
        }
        pickupAddressText
        paymentStatus
        paymentTransitions {
          id
          status
          paymentMethod
          totalAmount
          dueAmount
          paidAmount
          transactionId
          paymentTransactionDetails
          proof
          isProofApproved
          utrNumber
          paidOn
        }
        serviceTaxAmount
        gstAmount
        tdsAmount
        prepayment
        convenienceAmount
        total
        subtotal
        dueAmount
        pendingQuantity
        deliveredQuantity
        deliveryDate
        buyerGstBillingAddress
        sellerCommissionJson
        buyerCommissionJson
        buyerCommissionAmount
        sellerCommissionAmount
        createdAt
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        portOfDischarge {
          id
          name
        }
        portOfLoading {
          id
          name
        }
        createdByUserId
        updatedByUserId
        freightValue
        loadingValue
        orderDeliveryAddress
        sellerActionTaken
      }
      totalCount
      totalPages
    }
  }
`;

export const ORDERS_SUBSCRIPTION = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  subscription orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      order {
        id
        sellerCommissionAmount
        bid {
          id
          price
          quantity
          quantityUnit
          createdAt
          bidderRole
          status
          bidder {
            firstName
            lastName
          }
          parentBid {
            id
            childBids {
              id
              price
              quantity
              quantityUnit
              createdAt
              bidderRole
              bidder {
                firstName
                lastName
              }
            }
          }
          total
        }
        orderType
        offer {
          id
          offerType
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }
        demand {
          id
          demandType
        }
        forwardOffer {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        forwardDemand {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        foreignOffer {
          id
          expectedShipmentDate
          maxDeliveryDelay
          minDeliveryDelay
          minShipmentDelay
          maxShipmentDelay
        }
        foreignDemand {
          id
          maxDeliveryDelay
          minDeliveryDelay
        }
        quantityUnit
        isPaid
        isLogisticSelf
        prePaymentPercentage
        approvalStatus
        comment
        buyer {
          ...sellerInfo
          id
        }
        seller {
          ...sellerInfo
          kyc {
            gstLocation
          }
          id
        }
        status
        rate
        quantity
        rateUnit {
          ...rateUnitInfo
        }
        grade {
          id
          name
        }
        deliveryAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        billingAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        orderLogistics {
          id
          rateUnit {
            ...rateUnitInfo
          }
          invoice {
            id
            isCancelled
            invoiceStatus
          }
          driverName
          orderLogisticStatus
          driverNumber
          callingCode {
            id
            callingCode
          }
          logisticDeliveryTerm
          cancellationReason
          vehicle
          vehicleNumber
          transportName
          transportLR
          loadingCharges
          otherCharges
          freight
          weightSlipDoc
          lrDoc
          vehicleNumberImage
          loadingImage
          loadingQty
          loadingQtyUnit
          pickupAddress {
            id
            houseNumber
            street
            area
            city {
              id
            }
            state {
              id
            }
            country {
              id
            }
            pinCode
          }
        }
        pickupAddressText
        paymentStatus
        paymentTransitions {
          id
          status
          paymentMethod
          totalAmount
          dueAmount
          paidAmount
          transactionId
          paymentTransactionDetails
        }
        serviceTaxAmount
        gstAmount
        tdsAmount
        prepayment
        convenienceAmount
        total
        subtotal
        dueAmount
        pendingQuantity
        deliveredQuantity
        deliveryDate
        buyerGstBillingAddress
        createdAt
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        portOfDischarge {
          id
          name
        }
        portOfLoading {
          id
          name
        }
        createdByUserId
        updatedByUserId
        sellerActionTaken
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($order: OrderInput!) {
    updateOrder(order: $order)
  }
`;

export const SEARCH_DRIVERS = gql`
  query driversByName($name: String!) {
    driversByName(name: $name) {
      id
      driverName
      driverNumber
      vehicle
      vehicleNumber
      transportName
      transportLR
      loadingCharges
      otherCharges
      freight
      weightSlipDoc
      lrDoc
      vehicleNumberImage
      loadingImage
      status
      createdAt
      updatedAt
      rateUnit {
        id
        countryCode
        currencyName
        isoCurrencyCode
      }
    }
  }
`;
export const UPDATE_ORDER_STATUS = gql`
  mutation updateOrderStatus(
    $id: ID
    $status: OrderStatus
    $deliveredQuantity: Int
  ) {
    updateOrderStatus(
      id: $id
      status: $status
      deliveredQuantity: $deliveredQuantity
    )
  }
`;

export const UPDATE_PAYMENT_STATUS = gql`
  mutation updateOrderPaymentStatus($id: ID, $paymentStatus: PaymentStatus) {
    updateOrderPaymentStatus(id: $id, paymentStatus: $paymentStatus)
  }
`;

export const CREATE_PAYMENT_TRANSITION = gql`
  mutation createPaymentTransition($paymentTransition: PaymentTransitionInput) {
    createPaymentTransition(paymentTransition: $paymentTransition)
  }
`;

export const EXPORTS_ORDERS = gql`
  query exportOrders(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportOrders(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const GENERATE_INVOICE = gql`
  query generateInvoice($orderLogisticId: ID!) {
    generateInvoice(orderLogisticId: $orderLogisticId)
  }
`;

export const CANCEL_INVOICE = gql`
  query cancelInvoice($orderLogisticId: ID!) {
    cancelInvoice(orderLogisticId: $orderLogisticId)
  }
`;

export const DELETE_ADDRESS = gql`
  mutation deleteAddress($id: ID!) {
    deleteAddress(id: $id)
  }
`;

export const DELETE_ORDER_LOGISTICS = gql`
  mutation deleteOrderLogisticStatus($orderLogisticId: ID) {
    deleteOrderLogisticStatus(orderLogisticId: $orderLogisticId)
  }
`;

export const DELETE_ORDER = gql`
  mutation deleteOrder($id: ID!) {
    deleteOrder(id: $id)
  }
`;

export const GET_ORDER_BY_ID = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  query order($id: ID!) {
    order(id: $id) {
      id
      sellerCommissionAmount
      bid {
        id
        price
        quantity
        quantityUnit
        createdAt
        bidderRole
        status
        bidder {
          firstName
          lastName
        }
        parentBid {
          id
          childBids {
            id
            price
            quantity
            quantityUnit
            createdAt
            bidderRole
            bidder {
              firstName
              lastName
            }
          }
        }
        total
      }
      orderType
      offer {
        id
        offerType
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
      }
      demand {
        id
        demandType
      }
      forwardOffer {
        id
        maxDeliveryDelay
        minDeliveryDelay
      }
      forwardDemand {
        id
        maxDeliveryDelay
        minDeliveryDelay
      }
      foreignOffer {
        id
        expectedShipmentDate
        maxDeliveryDelay
        minDeliveryDelay
        minShipmentDelay
        maxShipmentDelay
      }
      foreignDemand {
        id
        maxDeliveryDelay
        minDeliveryDelay
      }
      quantityUnit
      isPaid
      isLogisticSelf
      prePaymentPercentage
      approvalStatus
      comment
      buyer {
        ...sellerInfo
        id
      }
      seller {
        ...sellerInfo
        kyc {
          gstLocation
        }
        id
      }
      status
      rate
      quantity
      rateUnit {
        ...rateUnitInfo
      }
      grade {
        id
        name
      }
      deliveryAddress {
        id
        houseNumber
        street
        area
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        country {
          id
          country
        }
        pinCode
      }
      billingAddress {
        id
        houseNumber
        street
        area
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        country {
          id
          country
        }
        pinCode
      }
      orderLogistics {
        id
        rateUnit {
          ...rateUnitInfo
        }
        invoice {
          id
          isCancelled
          invoiceStatus
        }
        driverName
        deliveryDate
        orderLogisticStatus
        driverNumber
        callingCode {
          id
          callingCode
        }
        logisticDeliveryTerm
        cancellationReason
        vehicle
        vehicleNumber
        transportName
        transportLR
        loadingCharges
        otherCharges
        freight
        weightSlipDoc
        lrDoc
        vehicleNumberImage
        loadingImage
        loadingQty
        loadingQtyUnit
        pickupAddress {
          id
          houseNumber
          street
          area
          city {
            id
          }
          state {
            id
          }
          country {
            id
          }
          pinCode
        }
      }
      pickupAddressText
      paymentStatus
      paymentTransitions {
        id
        status
        paymentMethod
        totalAmount
        dueAmount
        paidAmount
        transactionId
        paymentTransactionDetails
        proof
        isProofApproved
        utrNumber
        paidOn
      }
      serviceTaxAmount
      gstValue
      gstAmount
      tdsAmount
      prepayment
      convenienceAmount
      total
      subtotal
      dueAmount
      pendingQuantity
      deliveredQuantity
      deliveryDate
      buyerGstBillingAddress
      sellerCommissionJson
      buyerCommissionJson
      buyerCommissionAmount
      sellerCommissionAmount
      createdAt
      city {
        id
        cityName
      }
      state {
        id
        stateName
      }
      portOfDischarge {
        id
        name
      }
      portOfLoading {
        id
        name
      }
      createdByUserId
      updatedByUserId
      freightValue
      loadingValue
      orderDeliveryAddress
      sellerActionTaken
    }
  }
`;
